const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    // In dev, the proxy is handled by package.json "proxy" or Nginx, so relative paths work best
    return '/api/';
  }
  // In production, use the current origin
  return `${window.location.origin}/api/`;
};

const getWsUrl = () => {
  const url = new URL(window.location.href);
  const isSecure = url.protocol === 'https:';
  // Use ws:// or wss:// based on the current protocol
  return `${isSecure ? 'wss' : 'ws'}://${url.host}/`;
};

export const API_URL = getApiUrl();
export const WS_URL = getWsUrl();
